import React from 'react';
import './index.scss';
import { Popover } from 'tea-component';
import BubbleTip from './BubbleTip';

interface TableData {
  list: {
    lengendTitle?: string;
    title: string;
    color: string;
    num: string;
  }[];
  title?: string;
  titleNow?: string;
}

interface TableChartProps {
  tableData: TableData;
}

const TableChart: React.FC<TableChartProps> = (props) => {
  const { tableData } = props || {};
  const renderItems = (items: Array<any>) => {
    return items.map((item, index) => (
      <div
        key={index + item.num + item?.color}
        className="dbi-demographics-mulbar-item"
        style={{ width: item.num, background: item?.color }}
      />
    ));
  };

  const renderLegends = (items: Array<any>) => {
    return items.map((item, index) => (
      <div
        key={index + item?.color + item?.title}
        className="dbi-demographics-legend-item"
      >
        <div
          className="dbi-demographics-legend-radius"
          style={{ background: item?.color }}
        ></div>
        {item?.img ? (
          <img src={item.img} className="dbi-demographics-legend-img" />
        ) : (
          item?.lengendTitle ?? item?.title
        )}
      </div>
    ));
  };

  return (
    <Popover placement="right" overlay={<BubbleTip tableData={tableData} />}>
      <div className="dbi-demographics">
        <div className="dbi-demographics-mulbar">
          {tableData?.list && renderItems(tableData.list)}
        </div>
        <div className="dbi-demographics-legend">
          {tableData?.list && renderLegends(tableData.list)}
        </div>
      </div>
    </Popover>
  );
};

export default TableChart;
